<template>
  <div
    v-if="data"
    class="grap-page"
  >
    <section
      v-if="withdrawalFeeds.length"
      class="withdrawal-ticker"
    >
      <van-icon name="volume-o" />
      <van-swipe
        class="ticker-swipe"
        :autoplay="2600"
        vertical
        :show-indicators="false"
      >
        <van-swipe-item
          v-for="(feed, index) in withdrawalFeeds"
          :key="feed.acc + '-' + index"
        >
          <span>{{ feed.acc }} {{ $t('grapHome.withdrawFeed') }}: {{ moneyMark }} {{ formatMoney(feed.money) }}</span>
        </van-swipe-item>
      </van-swipe>
    </section>

    <section class="balance-card">
      <div class="balance-copy">
        <span>{{ $t('grapHome.accountBalance') }}</span>
        <strong><small>{{ moneyMark }}</small> {{ balanceAmount }}</strong>
        <em>{{ $t('grapHome.totalCommissionIncome') }}</em>
        <b>{{ moneyMark }} {{ totalCommission }}</b>
      </div>
      <span
        class="wallet-illustration"
        aria-hidden="true"
      ><i /></span>
    </section>

    <section
      v-if="hasPayablePendingOrder"
      class="content-card pending-card"
    >
      <div class="pending-row product-row">
        <span>{{ $t('grapHome.productName') }}</span>
        <strong>{{ pendingOrder.title || '--' }}</strong>
      </div>
      <div class="pending-row">
        <span>{{ $t('grapHome.taskProgress') }}</span>
        <strong>({{ taskProgressText }})</strong>
      </div>
      <div class="pending-row">
        <span>{{ $t('grapHome.orderPrice') }}</span>
        <strong>{{ moneyMark }} {{ formatMoney(pendingOrder.price) }}</strong>
      </div>
      <div class="pending-row">
        <span>{{ $t('shopd.commission') }}</span>
        <strong>{{ moneyMark }} {{ formatMoney(pendingOrder.fee) }}</strong>
      </div>
      <div class="pending-row">
        <span>{{ $t('grapHome.priceDifference') }}</span>
        <strong>{{ moneyMark }} {{ pendingOrderDifference }}</strong>
      </div>
      <div class="pending-row">
        <span>{{ $t('grapHome.orderStatus') }}</span>
        <strong>{{ $t('grapHome.pendingSubmission') }}</strong>
      </div>
      <div class="pending-divider" />
      <button
        type="button"
        class="primary-action"
        :class="{ disabled: dosubmit }"
        :disabled="dosubmit"
        @click="doorder"
      >
        {{ $t('grapHome.submitNow') }}
      </button>
    </section>

    <section
      v-else
      class="content-card product-preview-card"
    >
      <van-swipe
        v-if="productPages.length"
        class="product-swipe"
        :autoplay="3200"
        :loop="productPages.length > 1"
        :show-indicators="productPages.length > 1"
      >
        <van-swipe-item
          v-for="(page, pageIndex) in productPages"
          :key="pageIndex"
        >
          <div class="product-grid">
            <article
              v-for="product in page"
              :key="product.id"
              class="preview-product"
            >
              <img
                :src="previewImage(product)"
                alt=""
                @error="onProductImageError"
              >
              <span>{{ product.title || '--' }}</span>
              <strong>{{ moneyMark }} {{ formatMoney(product.price) }}</strong>
            </article>
          </div>
        </van-swipe-item>
      </van-swipe>
      <div
        v-else
        class="preview-empty"
      >
        {{ $t('grapHome.noPreviewProducts') }}
      </div>
      <button
        type="button"
        class="primary-action"
        @click="grap"
      >
        {{ $t('grapHome.singleLaunch') }}
      </button>
    </section>

    <section class="task-summary-card">
      <div class="task-counts">
        <button
          type="button"
          class="total-task-entry"
          @click="goToOrdering"
        >
          <strong>{{ totalTaskCount }}</strong>
          <span>{{ $t('grapHome.totalTasks') }}</span>
        </button>
        <button
          type="button"
          class="completed-task-entry"
          @click="goToSettledOrders"
        >
          <strong>{{ taskProgressCount }}</strong>
          <span>{{ $t('grapHome.taskProgress') }}</span>
        </button>
      </div>
      <div class="summary-divider" />
      <div class="summary-line">
        <span>{{ $t('grapHome.profitMargin') }}</span>
        <strong>{{ commissionRate }}</strong>
      </div>
      <button
        type="button"
        class="summary-line vip-level-entry"
        @click="goToVip"
      >
        <span>{{ $t('grapHome.membershipLevel') }}</span>
        <strong>
          <img
            src="../images/ban5/VIP.png"
            alt=""
            class="vip-level-icon"
          >
          {{ currentVipName }}
          <van-icon name="arrow" />
        </strong>
      </button>
    </section>

    <van-overlay
      :show="show1"
      @click="cancelGrabbing"
    >
      <div
        class="loading-wrapper"
        @click.stop
      >
        <div class="loading-block">
          <van-circle
            v-model="currentRate"
            :stroke-width="60"
            rate="0"
            size="100%"
            :color="gradientColor"
            :text="$t('shopd.graping')"
          />
        </div>
      </div>
    </van-overlay>

    <van-overlay
      :show="show3"
      @click="closeLuckyOrder"
    >
      <div
        class="dialog-wrapper"
        @click.stop
      >
        <div class="lucky-dialog">
          <button
            type="button"
            class="dialog-close"
            @click="closeLuckyOrder"
          >
            <van-icon name="cross" />
          </button>
          <h3>{{ $t('grapHome.luckyOrderTitle') }}</h3>
          <p>{{ $t('grapHome.luckyOrderCongrats') }}</p>
          <strong>{{ moneyMark }} {{ formatMoney(order && order.price) }}</strong>
          <span>{{ $t('shopd.commission') }} {{ moneyMark }} {{ formatMoney(order && order.fee) }}</span>
          <button
            type="button"
            class="primary-action"
            @click="openLuckyOrder"
          >
            {{ $t('grapHome.viewOrders') }}
          </button>
        </div>
      </div>
    </van-overlay>

    <van-overlay
      :show="show"
      @click="show = false"
    >
      <div
        class="dialog-wrapper order-wrapper"
        @click.stop
      >
        <div
          v-if="activeOrder"
          class="order-dialog"
        >
          <div class="dialog-header">
            <h3>{{ $t('grapHome.submitAllOrders') }}</h3>
            <button
              type="button"
              class="dialog-close"
              @click="show = false"
            >
              <van-icon name="cross" />
            </button>
          </div>
          <div class="order-dialog-body">
            <div class="dialog-meta">
              <span>{{ $t('shopds.onum') }}</span>
              <strong>{{ activeOrder.no || '--' }}</strong>
            </div>
            <div class="dialog-meta">
              <span>{{ $t('grapHome.timeToRushOrder') }}</span>
              <strong>{{ activeOrder.ct || '--' }}</strong>
            </div>
            <div class="dialog-product">
              <img
                :src="activeOrder.pic || productPlaceholder"
                alt=""
                @error="onProductImageError"
              >
              <div>
                <strong>{{ activeOrder.title || '--' }}</strong>
                <span>X{{ productQuantity }}</span>
              </div>
            </div>
            <div class="dialog-summary">
              <div>
                <span>{{ $t('grapHome.orderPrice') }}</span>
                <strong>{{ moneyMark }} {{ formatMoney(activeOrder.price) }}</strong>
              </div>
              <div>
                <span>{{ $t('shopd.commission') }}</span>
                <strong>{{ moneyMark }} {{ formatMoney(activeOrder.fee) }}</strong>
              </div>
            </div>
          </div>
          <div class="dialog-actions">
            <button
              type="button"
              class="secondary-action"
              @click="show = false"
            >
              {{ $t('shopd.cancelbtn') }}
            </button>
            <button
              type="button"
              class="confirm-action"
              :class="{ disabled: dosubmit }"
              :disabled="dosubmit"
              @click="doorder"
            >
              {{ $t('grapHome.confirmPayment') }}
            </button>
          </div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import Fetch from '../../utils/fetch';
import { formatProductQuantity } from '../../utils/order';
import productPlaceholder from '../images/ban5/order.png';
import Vue from 'vue';
import {
  Circle,
  Icon,
  Overlay,
  Swipe,
  SwipeItem,
  Toast
} from 'vant';

Vue.use(Circle)
  .use(Icon)
  .use(Overlay)
  .use(Swipe)
  .use(SwipeItem)
  .use(Toast);

export default {
  name: 'Grap',
  data() {
    return {
      cashes: [],
      data: null,
      dosubmit: false,
      gradientColor: {
        '0%': '#71d2cc',
        '100%': '#087780'
      },
      grabTimer: null,
      order: null,
      pendingAction: '',
      pendingOrder: null,
      previewProducts: [],
      productPlaceholder: productPlaceholder,
      currentRate: 0,
      show: false,
      show1: false,
      show3: false,
      tong: {},
      vip: null
    };
  },
  computed: {
    activeOrder() {
      return this.hasPayablePendingOrder ? this.pendingOrder : this.order;
    },
    balanceAmount() {
      return this.formatMoney(this.getBalanceValue());
    },
    commissionRate() {
      return this.formatRate(this.vip && this.vip.rate);
    },
    currentVipName() {
      if (this.data && this.data.vip_name) return this.data.vip_name;
      if (this.vip && this.vip.name) return this.vip.name;
      return 'VIP';
    },
    hasIncompleteOrder() {
      return !!this.pendingOrder;
    },
    hasPayablePendingOrder() {
      return this.hasIncompleteOrder && this.pendingAction === 'complete';
    },
    moneyMark() {
      return this.$t('utils.moneyMark');
    },
    pendingOrderDifference() {
      if (!this.pendingOrder) return this.formatMoney(0);
      return this.formatMoney(Math.max(0, this.toNumber(this.pendingOrder.price) - this.getBalanceValue()));
    },
    productPages() {
      var pages = [];
      var products = Array.isArray(this.previewProducts) ? this.previewProducts : [];
      for (var index = 0; index < products.length; index += 3) {
        pages.push(products.slice(index, index + 3));
      }
      return pages;
    },
    productQuantity() {
      return formatProductQuantity(this.activeOrder && this.activeOrder.pnum);
    },
    remainingTaskCount() {
      return Math.max(0, Math.floor(this.toNumber(this.tong && this.tong.anum)));
    },
    taskProgressCount() {
      var quota = Math.max(0, Math.floor(this.toNumber(this.tong && this.tong.onum)));
      return Math.max(0, quota - this.remainingTaskCount);
    },
    taskProgressText() {
      return this.taskProgressCount + '/' + this.totalTaskCount;
    },
    totalCommission() {
      return this.formatMoney(this.tong && this.tong.allfee);
    },
    totalTaskCount() {
      return this.taskProgressCount + this.remainingTaskCount;
    },
    withdrawalFeeds() {
      return Array.isArray(this.cashes) ? this.cashes.slice(0, 10) : [];
    }
  },
  created() {
    this.$parent.footer('item');
  },
  mounted() {
    this.start();
    this.loadWithdrawalFeeds();
  },
  beforeDestroy() {
    if (this.grabTimer) {
      clearTimeout(this.grabTimer);
      this.grabTimer = null;
    }
  },
  methods: {
    cancelGrabbing() {
      if (this.grabTimer) {
        clearTimeout(this.grabTimer);
        this.grabTimer = null;
      }
      this.show1 = false;
      this.currentRate = 0;
    },
    closeLuckyOrder() {
      this.show3 = false;
    },
    doorder() {
      var order = this.activeOrder;
      if (this.dosubmit || !order || !order.id) return;
      this.dosubmit = true;
      Fetch('/user/doorder', { id: order.id }).then(() => {
        this.dosubmit = false;
        this.order = null;
        this.pendingOrder = null;
        this.pendingAction = '';
        this.show = false;
        this.$toast({ duration: 2000, message: this.$t('shopd.corder') });
        this.start();
      }).catch(() => {
        this.dosubmit = false;
      });
    },
    goToSettledOrders() {
      this.$router.push('/ordersettle');
    },
    goToOrdering() {
      this.$router.push('/ordering');
    },
    goToVip() {
      this.$router.push('/vip');
    },
    formatMoney(value) {
      return this.toNumber(value).toFixed(2);
    },
    formatRate(value) {
      return Math.round(this.toNumber(value) * 100) / 100 + '%';
    },
    getBalanceValue() {
      if (!this.data) return 0;
      if (this.data.money !== undefined) return this.toNumber(this.data.money);
      return this.toNumber(this.data.baoku_money);
    },
    grap() {
      if (this.hasIncompleteOrder) {
        this.$router.push('/ordering');
        return;
      }
      if (this.show1) return;
      this.show1 = true;
      this.currentRate = 0;
      this.graptime(Math.floor(Math.random() * 50) + 20);
    },
    grapdata() {
      Fetch('/user/grap').then((response) => {
        var payload = response.data || {};
        if (payload.pendingOrder) {
          this.handlePendingOrder(payload);
          return;
        }
        if (!payload.id) {
          this.$router.push('/ordering');
          return;
        }
        this.setCurrentOrder(payload);
        if (payload.islucky) {
          this.show3 = true;
          this.$toast({ duration: 5000, message: this.$t('shopd.lorder') });
          return;
        }
        this.show = true;
      });
    },
    graptime(rate) {
      this.currentRate += rate;
      if (this.currentRate < 100) {
        this.grabTimer = setTimeout(() => this.graptime(rate), 1000);
        return;
      }
      this.grabTimer = null;
      this.show1 = false;
      this.grapdata();
    },
    handlePendingOrder(payload) {
      if (payload.action === 'complete' && payload.pendingOrder) {
        this.pendingOrder = payload.pendingOrder;
        this.pendingAction = 'complete';
        this.order = null;
        return;
      }
      this.$router.push('/ordering');
    },
    loadWithdrawalFeeds() {
      Fetch('/index/int').then((response) => {
        var payload = response.data || {};
        this.cashes = Array.isArray(payload.cashes) ? payload.cashes : [];
      }).catch(() => {
        this.cashes = [];
      });
    },
    onProductImageError(event) {
      if (event && event.target && event.target.src !== this.productPlaceholder) {
        event.target.src = this.productPlaceholder;
      }
    },
    openLuckyOrder() {
      this.show3 = false;
      this.show = true;
    },
    previewImage(product) {
      return product && product.img ? product.img : this.productPlaceholder;
    },
    setCurrentOrder(order) {
      this.order = order || null;
    },
    start() {
      Fetch('/user/basicinfo').then((response) => {
        var payload = response.data || {};
        this.data = payload;
        this.tong = payload.tong || {};
        this.vip = payload.vip || {};
        this.previewProducts = Array.isArray(payload.previewProducts) ? payload.previewProducts : [];
        this.pendingOrder = payload.pendingOrder || null;
        this.pendingAction = payload.pendingAction || '';
      });
    },
    toNumber(value) {
      var number = parseFloat(value);
      return isNaN(number) ? 0 : number;
    }
  }
};
</script>

<style lang="less" scoped>
.grap-page {
  min-height: 100vh;
  padding: 12px 16px 92px;
  overflow-x: hidden;
  box-sizing: border-box;
  color: #123d42;
  background:
    radial-gradient(circle at 100% 0, rgba(113, 210, 204, .15), transparent 31%),
    linear-gradient(180deg, #f3f9f8 0%, #ebf5f3 100%);
}
.withdrawal-ticker {
  height: 44px;
  padding: 0 14px;
  display: flex;
  align-items: center;
  gap: 9px;
  border-radius: 12px;
  box-sizing: border-box;
  border: 1px solid #c7e0dd;
  background: rgba(255, 255, 255, .94);
  color: #08646d;
  box-shadow: 0 8px 18px rgba(10, 73, 79, .06), inset 0 1px 0 #fff;
  font-size: 12px;
  line-height: 18px;
}
.withdrawal-ticker .van-icon { flex: 0 0 auto; font-size: 16px; }
.ticker-swipe { flex: 1; height: 20px; min-width: 0; }
.ticker-swipe span { display: block; overflow: hidden; white-space: nowrap; text-overflow: ellipsis; }
.balance-card, .content-card, .task-summary-card { border-radius: 18px; box-sizing: border-box; }
.balance-card {
  position: relative;
  min-height: 196px;
  margin-top: 16px;
  padding: 26px;
  overflow: hidden;
  border: 1px solid #075e67;
  background: linear-gradient(115deg, #063942 0%, #075a62 58%, #0c8188 100%);
  box-shadow: 0 14px 28px rgba(10, 71, 77, .18), inset 0 1px 0 rgba(255, 255, 255, .16);
}
.balance-card:after {
  position: absolute;
  right: -46px;
  bottom: -74px;
  width: 220px;
  height: 220px;
  border: 1px solid rgba(191, 231, 227, .13);
  border-radius: 50%;
  box-shadow: 0 0 0 34px rgba(191, 231, 227, .05), 0 0 0 68px rgba(191, 231, 227, .03);
  content: '';
}
.balance-copy { position: relative; z-index: 1; width: 72%; min-width: 0; }
.balance-copy > span, .balance-copy em, .balance-copy b { display: block; font-size: 14px; line-height: 20px; font-style: normal; font-weight: 400; }
.balance-copy > span, .balance-copy em { color: #c8ece8; }
.balance-copy > strong { display: block; margin: 13px 0 27px; color: #fff; font-size: 28px; line-height: 34px; font-weight: 800; letter-spacing: .4px; word-break: break-word; }
.balance-copy > strong small { font-size: 16px; }
.balance-copy b { margin-top: 8px; color: #71d2cc; font-weight: 600; }
.wallet-illustration { position: absolute; z-index: 1; right: 22px; top: 67px; width: 98px; height: 84px; border: 7px solid rgba(168, 231, 225, .35); border-radius: 4px; box-sizing: border-box; }
.wallet-illustration:before { position: absolute; content: ''; left: -34px; top: 27px; width: 37px; height: 70px; border: 7px solid rgba(168, 231, 225, .35); border-right: 0; border-radius: 6px 0 0 6px; box-sizing: border-box; }
.wallet-illustration:after { position: absolute; content: ''; left: 17px; top: 28px; width: 17px; height: 17px; border-radius: 50%; background: rgba(168, 231, 225, .48); }
.wallet-illustration i { position: absolute; right: -7px; top: -35px; width: 68px; height: 34px; border: 7px solid rgba(168, 231, 225, .35); border-bottom: 0; box-sizing: border-box; transform: skewY(15deg); transform-origin: bottom left; }
.content-card { margin-top: 18px; padding: 21px; border: 1px solid #c7e0dd; background: rgba(255, 255, 255, .97); box-shadow: 0 10px 21px rgba(10, 73, 79, .09), inset 0 1px 0 #fff; }
.product-preview-card { min-height: 318px; display: flex; flex-direction: column; }
.product-swipe { flex: 1; min-height: 191px; }
.product-grid { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 12px; }
.preview-product { min-width: 0; text-align: center; }
.preview-product img { display: block; width: 100%; aspect-ratio: 1 / 1; border: 1px solid #d7e9e7; border-radius: 10px; object-fit: cover; background: #e8f5f3; box-shadow: 0 5px 10px rgba(10, 73, 79, .06); box-sizing: border-box; }
.preview-product span, .preview-product strong { display: block; min-width: 0; overflow: hidden; text-overflow: ellipsis; }
.preview-product span { display: -webkit-box; height: 34px; margin-top: 8px; color: #60797c; font-size: 12px; line-height: 17px; white-space: normal; -webkit-box-orient: vertical; -webkit-line-clamp: 2; }
.preview-product strong { margin-top: 6px; color: #074b53; font-size: 16px; line-height: 22px; white-space: nowrap; }
.preview-empty { flex: 1; min-height: 191px; display: flex; align-items: center; justify-content: center; color: #71898b; font-size: 14px; }
.primary-action, .confirm-action, .secondary-action { min-height: 50px; border: 0; border-radius: 25px; box-sizing: border-box; font-size: 14px; line-height: 20px; font-weight: 800; }
.primary-action { width: 100%; min-height: 50px; margin-top: 18px; background: linear-gradient(135deg, #063942 0%, #087780 62%, #0c8d94 100%); box-shadow: 0 10px 18px rgba(11, 70, 76, .2), inset 0 1px 0 rgba(255, 255, 255, .16); color: #fff; letter-spacing: .2px; }
.primary-action:active, .confirm-action:active, .secondary-action:active { transform: translateY(1px); }
.primary-action.disabled, .confirm-action.disabled { opacity: .62; }
.pending-card { position: relative; padding: 20px 22px; overflow: hidden; }
.pending-card:before { position: absolute; top: 22px; bottom: 22px; left: 0; width: 4px; border-radius: 0 4px 4px 0; background: #71d2cc; content: ''; }
.pending-row { display: grid; grid-template-columns: 42% minmax(0, 1fr); column-gap: 12px; align-items: start; min-height: 36px; color: #60797c; font-size: 14px; line-height: 21px; }
.pending-row strong { min-width: 0; color: #074b53; font-weight: 700; text-align: right; word-break: break-word; }
.pending-row.product-row strong { overflow: hidden; white-space: nowrap; text-overflow: ellipsis; }
.pending-divider, .summary-divider { height: 1px; background: #deebea; }
.pending-divider { margin: 8px 0 1px; }
.task-summary-card { position: relative; margin-top: 18px; padding: 24px 24px 21px; overflow: hidden; border: 1px solid #075e67; background: linear-gradient(115deg, #063942 0%, #075a62 58%, #0c8188 100%); box-shadow: 0 12px 22px rgba(10, 71, 77, .17), inset 0 1px 0 rgba(255, 255, 255, .16); color: #f4fffe; }
.task-summary-card:before { position: absolute; top: -72px; right: -43px; width: 168px; height: 168px; border: 1px solid rgba(191, 231, 227, .13); border-radius: 50%; box-shadow: 0 0 0 25px rgba(191, 231, 227, .05); content: ''; }
.task-summary-card > * { position: relative; z-index: 1; }
.task-counts { display: grid; grid-template-columns: repeat(2, 1fr); text-align: center; }
.task-counts > * + * { border-left: 1px solid rgba(191, 231, 227, .32); }
.total-task-entry, .completed-task-entry { width: 100%; padding: 0; border: 0; background: transparent; color: inherit; font: inherit; cursor: pointer; }
.total-task-entry:active, .completed-task-entry:active { opacity: .76; }
.task-counts strong, .task-counts span { display: block; }
.task-counts strong { font-size: 28px; line-height: 34px; font-weight: 500; letter-spacing: .3px; }
.task-counts span, .summary-line { font-size: 14px; line-height: 20px; }
.task-counts span { margin-top: 8px; color: #bfe7e3; }
.summary-divider { margin: 20px 0 12px; background: rgba(191, 231, 227, .35); }
.summary-line { display: flex; justify-content: space-between; gap: 16px; margin-top: 10px; color: #c8ece8; }
.summary-line strong { min-width: 0; color: #fff; font-weight: 600; text-align: right; word-break: break-word; }
.vip-level-entry { width: 100%; padding: 0; border: 0; background: transparent; font: inherit; text-align: left; cursor: pointer; }
.vip-level-entry strong { display: inline-flex; align-items: center; justify-content: flex-end; gap: 5px; }
.vip-level-entry:active { opacity: .76; }
.vip-level-icon { width: 21px; height: 21px; object-fit: contain; }
.loading-wrapper, .dialog-wrapper { min-height: 100vh; display: flex; align-items: center; justify-content: center; padding: 20px; box-sizing: border-box; }
.loading-block { width: 148px; height: 148px; padding: 16px; border-radius: 18px; border: 1px solid #c7e0dd; background: #fff; box-shadow: 0 18px 44px rgba(0, 41, 47, .3); box-sizing: border-box; }
.lucky-dialog, .order-dialog { width: 100%; max-width: 440px; border: 1px solid #c7e0dd; border-radius: 16px; background: #fff; box-shadow: 0 18px 44px rgba(0, 41, 47, .3); overflow: hidden; }
.lucky-dialog { position: relative; padding: 30px 24px 24px; text-align: center; }
.lucky-dialog h3, .lucky-dialog p, .lucky-dialog strong, .lucky-dialog span { display: block; }
.lucky-dialog h3 { margin: 0; color: #074b53; font-size: 16px; line-height: 22px; }
.lucky-dialog p, .lucky-dialog span { color: #60797c; font-size: 14px; line-height: 20px; }
.lucky-dialog p { margin: 20px 0 7px; }
.lucky-dialog strong { color: #087780; font-size: 28px; line-height: 34px; }
.lucky-dialog span { margin-top: 14px; }
.dialog-header { min-height: 60px; padding: 0 20px; display: flex; align-items: center; justify-content: space-between; background: linear-gradient(135deg, #063942 0%, #0c8188 100%); color: #fff; }
.dialog-header h3 { margin: 0; font-size: 16px; line-height: 22px; }
.dialog-close { width: 30px; height: 30px; padding: 0; border: 1px solid currentColor; border-radius: 50%; background: rgba(255, 255, 255, .14); color: inherit; display: inline-flex; align-items: center; justify-content: center; font-size: 16px; }
.lucky-dialog .dialog-close { position: absolute; top: 12px; right: 12px; color: #60797c; background: #f4fbfa; }
.order-dialog-body { padding: 18px 20px; }
.dialog-meta { display: grid; grid-template-columns: 42% minmax(0, 1fr); gap: 8px; min-height: 36px; align-items: center; border-bottom: 1px dashed #deebea; color: #60797c; font-size: 14px; line-height: 20px; }
.dialog-meta strong { min-width: 0; color: #074b53; font-size: 12px; text-align: right; word-break: break-all; }
.dialog-product { display: grid; grid-template-columns: 76px minmax(0, 1fr); gap: 14px; margin-top: 16px; padding: 12px; border: 1px solid #d7e9e7; border-radius: 10px; background: #f4fbfa; }
.dialog-product img { width: 76px; height: 76px; border-radius: 7px; object-fit: cover; background: #e8f5f3; }
.dialog-product div { min-width: 0; }
.dialog-product strong, .dialog-product span { display: block; }
.dialog-product strong { color: #123d42; font-size: 14px; line-height: 21px; overflow: hidden; display: -webkit-box; -webkit-box-orient: vertical; -webkit-line-clamp: 2; }
.dialog-product span { margin-top: 12px; color: #087780; font-size: 14px; line-height: 20px; }
.dialog-summary { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); margin-top: 14px; border: 1px solid #c7e0dd; border-radius: 10px; overflow: hidden; }
.dialog-summary > div { min-width: 0; padding: 12px; }
.dialog-summary > div + div { border-left: 1px solid #c7e0dd; }
.dialog-summary span, .dialog-summary strong { display: block; }
.dialog-summary span { color: #60797c; font-size: 12px; line-height: 18px; }
.dialog-summary strong { margin-top: 5px; color: #074b53; font-size: 14px; line-height: 20px; word-break: break-word; }
.dialog-actions { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 12px; padding: 0 20px 20px; }
.secondary-action { border: 1px solid #a8d5d0; background: #f4fbfa; color: #08646d; }
.confirm-action { background: linear-gradient(135deg, #063942 0%, #0c8188 100%); color: #fff; }
@media (min-width: 600px) { .grap-page { max-width: 650px; margin: 0 auto; } }
</style>
